<template>
  <div v-if="header.key === 'value'">
    <span v-if="isLanguageOfLectureRow">
      {{ translatedValue }}
    </span>
    <span v-else-if="isLeadersRow">
      <prk-tags :value="leaders" without-remove />
    </span>
    <span v-else-if="isUnitNameRow">{{ realUnitName() }}</span>
    <span v-else>
      {{ translatedValue }}
    </span>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import PrkTags from '../../../../PrkTags'
import { translateBasicInformationValue } from '../../../../../helpers/translate_form_of_class'
const { mapState } = createNamespacedHelpers('syllabusFill')

export default {
  name: 'basic-information-about-subject-value',
  components: {
    PrkTags,
  },
  data () {
    return {
      units: [],
    }
  },
  props: {
    header: { required: true, type: Object },
    information: { required: true, type: String },
    value: { type: [String, Number, Array], default: '' },
  },
  computed: {
    ...mapState(['leaders']),
    languageOfLecture () {
      return Number(this.value) === 0 ? 'Polski' : 'English'
    },
    language () {
      return this.$i18n.locale === 'en' ? this.$i18n.locale : this.$store.state.syllabusFill.language
    },
    translatedValue () {
      return translateBasicInformationValue(
        this.isLanguageOfLectureRow ? this.languageOfLecture : this.value,
        this.information,
        this.language
      )
    },
    isLanguageOfLectureRow () {
      return this.information === 'language'
    },
    isLeadersRow () {
      return this.information === 'leading_persons'
    },
    isUnitNameRow () {
      return this.information === 'row_3'
    },
  },
  created () {
    if (this.information === 'row_3') {
      this.getUnits()
    }
  },
  methods: {
    async getUnits () {
      const { data: units } = await this.$api.get('unit_names')
      this.units = units.map(unit => {
        return {
          text: unit.attributes.name,
          value: unit.id,
        }
      })
    },
    realUnitName () {
      if (this.value) {
        const unit = this.units.find(unit => unit.value === this.value)
        if (unit) {
          return unit.text
        }
      }
    },
  },
  watch: {
    information: {
      deep: true,
      handler () {
        if (this.information === 'row_3') {
          this.getUnits()
        }
      },
    },
  },
}
</script>
